/**
 * @file Project
 * @desc Manage project objects.
 */

import { createObject } from '@/utils/objects.js'

export const Project = {
  defaults: {
    // Database properties.
    project_id: null,
    project_code: null,
    project_name: null,

    // View properties.
    billingCode: null,
    contractBillingRate: null,
    contractBillingType: null,
    contractBillingUnit: null,
    contractStatus: null,
    contractType: null,
    docs: [],
    emailAccountManager: null,
    emailProjectSalesContact: null,
    emailProjectSupporters: [],
    emailProjectWatchers: [],
    endDate: null,
    isActive: true,
    isArchived: false,
    isDeleted: false,
    isLinkedToSheet: false,
    isPublished: false,
    isTest: false,
    isBillableByDefault: false,
    launchDateActual: null,
    launchDateEstimate: null,
    monthlyHours: 0,
    parentProjectId: null,
    publishedAt: null,
    publishedBy: null,
    projectCode: null, // Mapped from project_code from database.
    projectDescription: '',
    projectHours: 0,
    projectId: null, // Mapped from project_id from database.
    projectName: '', // Mapped from project_name from database.
    projectStatus: null,
    projectType: null,
    projectTypes: [],
    statusWeight: null,
    projectPlatforms: [], // Array of platform values selected for this project
    projectOwner: null, // Email or name of project owner
    estimatedProjectValue: null, // Estimated monetary value of the project
    startDate: null,
    tempCode: null, // Temporary sheet code before a real project code is assigned
  },
}

export const makeProject = (project) => createObject(Project.defaults, project)

export default Project
